import { extractText } from '../codelists/lookup.js';
import type { JsonMonster, Monster } from '../types/index.js';
import { unwrapName, unwrapNumber } from '../types/index.js';

export class MonsterModel {
  readonly id: string | null;            // DB row id
  readonly name: string;
  readonly type: string | null;
  readonly upperDepth: number;
  readonly lowerDepth: number;
  readonly date: string | null;
  readonly meetpuntName: string | null;
  readonly meetpuntGuid: string | null;
  readonly description: string | null;
  readonly raw: JsonMonster;

  constructor(data: JsonMonster) {
    this.raw = data;
    this.id = extractText(data.guid) ?? null;
    this.name = unwrapName(data.naam ?? data.identificatie) ?? 'Onbekend';
    this.type = extractText(data.typeMonster) || null;
    this.upperDepth = unwrapNumber(data.upperDepth_cm ?? data.diepteVan) ?? 0;
    this.lowerDepth = unwrapNumber(data.lowerDepth_cm ?? data.diepteTot) ?? 0;
    this.date = extractText(data.datum) || null;
    this.meetpuntName = unwrapName(data.meetpuntName ?? data.gekoppeld_meetpunt) ?? null;
    this.meetpuntGuid = extractText(data.meetpuntGuid) || null;
    this.description = extractText(data.omschrijving) || null;
  }

  /**
   * Construct a MonsterModel from a normalized flat Monster DB row.
   */
  static fromFlat(monster: Monster & { boring_id?: string }): MonsterModel {
    const json: JsonMonster = {
      guid: monster.id,
      meetpuntGuid: monster.boringId ?? (monster as any).boring_id ?? undefined,
      naam: monster.name ? { waarde: monster.name } : undefined,
      identificatie: monster.identificatie ? { waarde: monster.identificatie } : undefined,
      typeMonster: monster.type ? { waarde: monster.type } : undefined,
      upperDepth_cm: monster.upperDepth != null ? { waarde: monster.upperDepth } : undefined,
      lowerDepth_cm: monster.lowerDepth != null ? { waarde: monster.lowerDepth } : undefined,
      datum: monster.datum ? { waarde: monster.datum } : undefined,
      omschrijving: monster.opmerking ? { waarde: monster.opmerking } : undefined,
    };
    return new MonsterModel(json);
  }
}
